import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import toastr from '../toastr';
import config from '../../config';
import FileNotFound from '../FileNotFound';
import Form from '../form/Form';
import ApiService from '../../services/ApiService';
import ModalContext from './ModalContext';

const LinkAttachment = props => {
  const { attachmentIds = [], itemName } = props;
  const { close } = useContext(ModalContext);

  const suffix = attachmentIds.length > 1 ? 'these attachments' : 'this attachment';

  const layout = [
    {
      type: 'section',
      style: 'blue',
      label: 'Instructions',
      fields: [
        {
          control: 'paragraph',
          data: `Select one or more list items that you would like to link to ${suffix}.`,
          name: 'info',
        },
      ],
    },
    {
      control: 'Tags',
      validation: {
        page: itemName,
      },
      label: 'List Items',
      name: 'itemId',
    },
  ];

  if (!itemName) {
    return <FileNotFound>Invalid itemName</FileNotFound>;
  }

  const submit = payload => {
    const { itemId } = payload;

    ApiService.post('list/attachments/link', {
      itemName,
      itemId,
      attachmentId: attachmentIds,
    }).then(() => {
      toastr.success('Attachments Linked');
      props.unSelectAll();
      close();
    });
  };

  const onCancel = () => {
    close();
  };

  return (
    <div className="link-attachments">
      <Form layout={layout} submit={submit} onCancel={onCancel} exportFormat="object" />
      <div className="link-file-list">
        <div className="link-file-label">Attachments to be linked ({`${attachmentIds.length}`})</div>
        <div className="link-files">
          {attachmentIds.map(id => {
            return (
              <img
                src={`${config.serverUrl}/api/attachment/${id}/thumbnail?useid=1&resize=50`}
                alt="attachment"
                key={id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

LinkAttachment.propTypes = {
  attachmentIds: PropTypes.array,
  itemName: PropTypes.string,
  unSelectAll: PropTypes.func,
};

export default LinkAttachment;
